const setCalendarBtn = () => {
  const btn = document.getElementById('js-calendar-btn'),
    calendar = document.getElementById('js-calendar');
  if (!btn || !calendar) return;

  btn.addEventListener('click', () => {
    btn.classList.toggle('is-active');
    calendar.classList.toggle('is-open');
  })
};

export default setCalendarBtn;